import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import { Lazyload } from 'vant'; // 懒加载
import { Skeleton } from 'vant'; // 骨架屏
import Base64 from '@/utils//base.js'
import vueEsign from 'vue-esign'
import api from '@/api/login.js'

Vue.prototype.$Base64 = Base64

Vue.use(vueEsign)

Vue.use(Skeleton); // 骨架屏
Vue.use(Vant);
Vue.use(Lazyload); // 懒加载
import { CountDown } from 'vant';
//倒计时
Vue.use(CountDown);

//二维码
// import VueBarcode from 'vue-barcode';
// Vue.component('barcode', VueBarcode)


// 定时自动刷新token
setInterval(() => {
  refreshTokenAPI()
}, 1728000000);

function refreshTokenAPI() {
  let openId = sessionStorage.getItem('openId')
  api.Login({ openId: openId }).then(res => {
    if (res.data.code == 200) {
      sessionStorage.setItem('token', res.data.data.accessToken
      )
    }
  }).catch(err => { })
}


import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
